import { render, staticRenderFns } from "./FormPublications.vue?vue&type=template&id=790329da&scoped=true"
import script from "./FormPublications.vue?vue&type=script&lang=js"
export * from "./FormPublications.vue?vue&type=script&lang=js"
import style0 from "./FormPublications.vue?vue&type=style&index=0&id=790329da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790329da",
  null
  
)

export default component.exports